export default __webpack_public_path__ + "eye.3d7bf173bad440e0.svg";